import apiPaths from '../api-paths';

export default {
  index(page = 1, perPage = 10, search = '') {
    return axios.get(`${ apiPaths.API }/importable-clients/import`, {
      params: {
        page,
        per_page: perPage,
        ...(search && { search }),
      },
    });
  },
  uploadFile(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${ apiPaths.API }/importable-clients/upload-file`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  show(id) {
    return axios.get(`${ apiPaths.API }/importable-clients/${ id }`);
  },
  showFiles(id) {
    return axios.get(`${ apiPaths.API }/importable-clients/${ id }/files`);
  },
  update(id, data) {
    return axios.put(`${ apiPaths.API }/importable-clients/${ id }`, data);
  },
  delete(id) {
    return axios.delete(`${ apiPaths.API }/importable-clients/${ id }`);
  },
  import(id) {
    return axios.post(`${ apiPaths.API }/importable-clients/${ id }/import`);
  },
  importClients() {
    return axios.post(`${ apiPaths.API }/importable-clients/import`);
  },
  fetchAllGusData() {
    return axios.post(`${ apiPaths.API }/importable-clients/fetch-gus-data`);
  },
  checkVatWhitelist() {
    return axios.post(`${ apiPaths.API }/importable-clients/check-vat-whitelist`);
  },
  uploadClientFile(importableClientId, file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(
      `${ apiPaths.API }/importable-clients/${ importableClientId }/files`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
  },
  deleteFile(fileId) {
    return axios.delete(`${ apiPaths.API }/importable-clients/${ fileId }/files`);
  },
};
